import React from "react";
import "./core.css";

// ‼️ Swap these with real images in your /Assets folder
import img1 from "../Assets/critical.png";
import img2 from "../Assets/multispeciality.png";
import img3 from "../Assets/highlyqualified.png";
import img4 from "../Assets/welltrained.png";
import img5 from "../Assets/rapidemergency.png";
import img6 from "../Assets/minimalwaittime.png";
import img7 from "../Assets/cuttingedge.png";
import img8 from "../Assets/latesttech.png";

const data = [
  { title: "24X7 Critical Care", img: img1 },
  { title: "Multi Speciality Care", img: img2 },
  { title: "Highly Qualified Doctors Team", img: img3 },
  { title: "Well Trained & Experienced Clinical Teams", img: img4 },
  { title: "Rapid Emergency Response", img: img5 },
  { title: "Minimal Wait Time", img: img6 },
  { title: "Cutting Edge Facilities", img: img7 },
  { title: "Latest Technology", img: img8 },
];

export default function CoreCompetencies() {
  return (
    <section className="core-competencies">
      <h2>Our Core Competencies</h2>

      <div className="competency-grid">
        {data.map(({ title, img }, idx) => (
          <div className="competency-card" key={idx}>
            <img src={img} alt={title} />
            <div className="caption">{title}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
